import React, { useState } from "react";

export default function PhImage({ src, alt, className = "", ratio = "16/10" }) {
  const [failed, setfailed] = useState(false);

  return (
    <div className={`ph-well ${className}`.trim()} style={{ aspectRatio: ratio }}>
      <div className="ph-fallback">
        <span className="ph-fallback-pill">NO PREVIEW</span>
      </div>
      {!failed && (
        <img
          className="ph-img"
          src={src}
          alt={alt}
          onError={() => setfailed(true)}
        />
      )}
    </div>
  );
}
